import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef
} from '@angular/core';

import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { cloneDeep,groupBy, get, has, isEmpty } from 'lodash';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";



@Component({
  selector: 'gen-chart-widget',
  templateUrl: './chart-widget.component.html',
  styleUrls: ['./chart-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget()
export class ChartWidgetComponent implements OnInit, IWidgetItem {

  constructor(private _changeDetector: ChangeDetectorRef) { }

  public isDataLoaded = false;
  public readonly = true;
  @Input() public widgetConfig = undefined;
  public noDataMessage = this.widgetConfig ? get(this.widgetConfig.widgetPayload, 'noDataMessage'): 'No data to display';
  public showCount:number = 4; //default count.

  @Input() set widgetData(widgetData: any) {
    this.data = cloneDeep(widgetData);
    this.setResults();
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  @Input()
  public data;

  public resultList;

  ngOnInit() {
    this.setResults();
    this.noDataMessage = this.widgetConfig ? get(this.widgetConfig.widgetPayload, 'noDataMessage'): 'No data to display';
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }
  

  private setResults() {
    this.resultList = [];
    if (!this.data) {
      return;
    }
    if (Array.isArray(this.data)) {
      if(this.widgetConfig && get(this.widgetConfig.widgetPayload, 'groupBy')) {
        let groupedData = groupBy(this.data, item => get(item,this.widgetConfig.widgetPayload.groupBy));
        let finalData = [];
        for (let i in groupedData) {
          let tempData = groupedData[i];
          if (Array.isArray(tempData)) {
            tempData = tempData.sort((a, b) => {
              const aDate = new Date(get(a, this.widgetConfig.widgetPayload?.binding?.date?.path))
              const bDate = new Date(get(b, this.widgetConfig.widgetPayload?.binding?.date?.path))
              if (aDate instanceof Date && bDate instanceof Date) {
                return (aDate.getTime() > bDate.getTime() ? -1 : 1);
              }
              return 1;
            });
            finalData.push(tempData[0]);
          }
        }
        if(this.widgetConfig && has(this.widgetConfig.widgetPayload, 'showCount')){
          this.showCount = get(this.widgetConfig.widgetPayload, 'showCount');
          this.resultList = finalData.filter(element => finalData.indexOf(element) < this.showCount);
        }else{
          this.resultList =  finalData;
        }
      }else{
        this.resultList = this.data;
      }
    } else if (!isEmpty(this.data)){
      this.resultList = [this.data];
    }
    this.isDataLoaded = true;
  }
}
